export const message = {
    common: {
        name: "fund",
        networkError: "network anomaly",
        loading: "loading...",
        loginTimeout: "You haven't operated for a long time, please close and reopen!",
        notFound: "Sorry, no related resources were found!",
        notSupport: "unable to process the operation",
        welcome: "Welcome to use fund",
        loadingFail: "Loading failed, please click to retry!",
        optFail: "operation failed!",
        loginBtn: "LOG IN",
        regbtn: "SIGN UP",
        listNoMore: "No more",
        listError: "Request failed, click to reload",
        cancelText: "Cancel",
        confirmText: "Confirm"
    },
    title: {
        404: "can not found",
        403: "access error",
        home: "home",
        timeout: "login timeout",
        login: "login",
        entry: "uprp",
        authCallback: "uprp",
        cardWallet: "card wallet",
        couponWallet: "coupon wallet",
        combinedWallet: "Card & Coupon",
        cardlist: "card list",
        mall: "points mall",
        bindCallback: "uprp",
        regCallback: "uprp",
        detail: "details",
        bindCard: "Binding Membership Card",
        invalidCards: "Invalid card",
        memCardDetail: "Member card details",
        invalidCoupons: "Expired coupon",
        couponDetail: "Coupon detail",
        storeList: "Store list",
        timelimit: "detail",
        commodity: "detail",
        clause: "Terms of use",
        privacy: "Privacy Agreement"
    }
}